export default {
  cbam_news: "CBAM新闻",
  view_all_news: "查看所有新闻",
  search_news: "搜索新闻...",
  no_news: "暂无新闻",
  fetch_news_failed: "获取新闻失败",
};
